import { useState, useEffect } from 'react';
import { supabase } from '../../lib/supabase';

const TestInsertForm = () => {
  const [formData, setFormData] = useState({
    nome_vetrina: '',
    categoria: '',
    zona: ''
  });
  
  const [categories, setCategories] = useState([]);
  const [zones, setZones] = useState([]);
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Load categories
  useEffect(() => {
    const loadCategories = async () => {
      const { data, error } = await supabase?.from('vetrine_categories')?.select('*')?.order('label');
      if (error) {
        console.error('Error loading categories:', error);
      } else {
        setCategories(data || []);
      }
    };
    loadCategories();
  }, []);

  // Load zones
  useEffect(() => {
    const loadZones = async () => {
      const { data, error } = await supabase?.from('vetrine_zones')?.select('*')?.order('label');
      if (error) {
        console.error('Error loading zones:', error);
      } else {
        setZones(data || []);
      }
    };
    loadZones();
  }, []);

  const handleSubmit = async (e) => {
    e?.preventDefault();
    setIsSubmitting(true);
    setMessage('');

    try {
      // Direct INSERT to vetrine_stores
      const { data, error } = await supabase?.from('vetrine_stores')?.insert({
          nome_negozio: formData?.nome_vetrina,
          categoria: formData?.categoria,
          zona: formData?.zona,
          indirizzo: 'Test',
          telefono: '0000000000'
        })?.select()?.single();

      // Console log della risposta
      console.log('📊 RISPOSTA SUPABASE INSERT:', { data, error });

      if (error) {
        setMessage(`❌ ERRORE: ${error?.message}`);
      } else {
        setMessage('✅ Inserimento riuscito');
        // Reset form
        setFormData({ nome_vetrina: '', categoria: '', zona: '' });
      }
    } catch (err) {
      console.error('Exception:', err);
      setMessage(`❌ ERRORE: ${err?.message}`);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div style={{ padding: '40px', maxWidth: '600px', margin: '0 auto' }}>
      <h1 style={{ marginBottom: '30px' }}>TEST INSERIMENTO DATABASE</h1>
      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
        {/* Nome Vetrina */}
        <div>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
            Nome Vetrina:
          </label>
          <input
            type="text"
            value={formData?.nome_vetrina}
            onChange={(e) => setFormData({ ...formData, nome_vetrina: e?.target?.value })}
            required
            style={{
              width: '100%',
              padding: '10px',
              border: '1px solid #ccc',
              borderRadius: '4px',
              fontSize: '16px'
            }}
          />
        </div>

        {/* Categoria */}
        <div>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
            Categoria:
          </label>
          <select
            value={formData?.categoria}
            onChange={(e) => setFormData({ ...formData, categoria: e?.target?.value })}
            required
            style={{
              width: '100%',
              padding: '10px',
              border: '1px solid #ccc',
              borderRadius: '4px',
              fontSize: '16px'
            }}
          >
            <option value="">Seleziona categoria</option>
            {categories?.map((cat) => (
              <option key={cat?.id} value={cat?.value}>
                {cat?.label}
              </option>
            ))}
          </select>
        </div>

        {/* Zona */}
        <div>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
            Zona:
          </label>
          <select
            value={formData?.zona}
            onChange={(e) => setFormData({ ...formData, zona: e?.target?.value })}
            required
            style={{
              width: '100%',
              padding: '10px',
              border: '1px solid #ccc',
              borderRadius: '4px',
              fontSize: '16px'
            }}
          >
            <option value="">Seleziona zona</option>
            {zones?.map((zone) => (
              <option key={zone?.id} value={zone?.value}>
                {zone?.label}
              </option>
            ))}
          </select>
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          disabled={isSubmitting}
          style={{
            padding: '12px 24px',
            backgroundColor: isSubmitting ? '#ccc' : '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            fontSize: '16px',
            fontWeight: 'bold',
            cursor: isSubmitting ? 'not-allowed' : 'pointer'
          }}
        >
          {isSubmitting ? 'Invio in corso...' : 'INVIA TEST'}
        </button>
      </form>
      {/* Message Display */}
      {message && (
        <div
          style={{
            marginTop: '30px',
            padding: '20px',
            backgroundColor: message?.includes('✅') ? '#d4edda' : '#f8d7da',
            border: `1px solid ${message?.includes('✅') ? '#c3e6cb' : '#f5c6cb'}`,
            borderRadius: '4px',
            fontSize: '18px',
            fontWeight: 'bold'
          }}
        >
          {message}
        </div>
      )}
      {/* Instructions */}
      <div style={{ marginTop: '40px', padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '4px' }}>
        <h3>Istruzioni:</h3>
        <ol>
          <li>Compila i 3 campi</li>
          <li>Clicca "INVIA TEST"</li>
          <li>Controlla il messaggio qui sopra</li>
          <li>Apri la console del browser (F12) per vedere il log della risposta Supabase</li>
        </ol>
      </div>
    </div>
  );
};

export default TestInsertForm;